/*
 * @Author: your name
 * @Date: 2021-12-02 14:28:33
 * @LastEditTime: 2024-12-17 15:26:52
 * @LastEditors: zhangyuan your_email
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /report-template/src/store/actions.ts
 */
import types from './mutation-types'
import {ActionContext} from 'vuex'
import {State} from './state'


export default {
    savePhotoInfo({commit}: ActionContext<State, State>, data: any): void {
        commit(types.SAVE_PHOTO_INFO, data)
    },
    saveDataInfo({commit}: ActionContext<State, State>, data: any): void {
        commit(types.SAVE_DATA_INFO, data)
    },
    saveReportDetectVersion({commit}: ActionContext<State, State>, data: any): void {
        commit(types.SAVE_REPORT_DETECT_VERSION, data)
    },
    saveIsDisplay({commit}: ActionContext<State, State>, data: any): void {
        commit(types.SAVE_IS_DISPLAY, data)
    },
    saveOpacityStyle({commit}: ActionContext<State, State>, data: any): void {
        commit(types.SAVE_OPACITY_STYLE, data)
    },
    saveCheckItemShow({commit}: ActionContext<State, State>, data: any): void {
        commit(types.SAVE_CHECK_ITEM_SHOW, data)
    },
    saveIdleFishInfo({commit}: ActionContext<State, State>, data: any): void {
        commit(types.SAVE_IDLE_FISH_INFO, data)
    },
    saveTocOnlyShowFlaw({commit}: ActionContext<State, State>, data: any): void {
        commit(types.SAVE_TOCONLYSHOWFLAW, data)
    },
    savePageScrollTop({commit}: ActionContext<State, State>, data: any): void {
        commit(types.SAVE_PAGESCROLLTOP, data)
    },
    // 存储c端检测报告是否为新能源车
    saveIsNormal({commit}: ActionContext<State, State>, res: any): void {
        commit(types.SAVE_ISNORMAL, res);
    },
    // 存储c端检测报告检测结论
    saveReportResultList({commit}: ActionContext<State, State>, res: any): void {
        console.log('saveReportResultList:', res);
        commit(types.SAVE_REPORTRESULTLIST, res);
    },
    // 存储c端检测报告检测结论
    saveVersion240530({commit}: ActionContext<State, State>, res: any): void {
        commit(types.SAVE_VERSION240530, res);
    },
    saveVersion240702({commit}: ActionContext<State, State>, res: any): void {
        commit(types.SAVE_VERSION240702, res);
    },
    saveVersion240704({commit}: ActionContext<State, State>, res: any): void {
        commit(types.SAVE_VERSION240704, res);
    },
    saveVersion240326({commit}: ActionContext<State, State>, res: any): void {
        commit(types.SAVE_VERSION240326, res);
    },
    saveVersion241226({commit}: ActionContext<State, State>, res: any): void {
        commit(types.SAVE_VERSION241226, res);
    },
    saveVersion250218({commit}: ActionContext<State, State>, res: any): void {
        commit(types.SAVE_VERSION250218, res);
    }
}
